import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Badge, Alert, Row, Col, UncontrolledTooltip } from 'reactstrap';
import {
  QUESTION_TYPE,
  RESULT_STATUS,
  SHOW_ANSWERS,
  UNIT_STATUS,
} from 'constants/constants';
import { parseHtml } from 'helpers/index';
import { useUnit } from 'hooks/units/index';
import DragDropResult from './DragDropResult';
import stylesCourse from 'styles/Course.module.scss';
import DragDropResultpage from './DragDropPageResult';
import OrderingResult from './OrderingResult';
import MTPchoiceResult from './MTPchoiceResult';
import FillTheGapResult from './FillTheGapResult';
import theme from 'constants/theme';
import { Check, X } from 'react-feather';
import FreeTextMarking from './manual-marking/free-text';
import FillInTheBlankMarking from './manual-marking/fill-in-blank';
import MultipleChoiceMarking from './manual-marking/multiple-choice';
import DragDropMarking from './manual-marking/drag-drop';
import OrderingMarking from './manual-marking/ordering';
import FillInTheGapMarking from './manual-marking/fill-in-the-gap';
import AssignmentMarking from './manual-marking/assignment';
import AssignmentResult from './assignment-result';

const ResultItem = ({ result, index }) => {
  const unitSelected = useUnit();
  const config = unitSelected?.config;

  const isManualMarking = (questionType) => {
    return (
      ((config?.questionType?.[questionType] &&
        config?.manualMarking?.status) ||
        result?.questionManualMarking) &&
      unitSelected?.status === UNIT_STATUS.PENDING
    );
  };

  const showCorrect =
    result?.status !== RESULT_STATUS.MARKED &&
    result?.status !== RESULT_STATUS.NOT_MARKED &&
    (config?.completion?.showCorrect === SHOW_ANSWERS.ALWAYS &&
    result?.status !== RESULT_STATUS.NOTASSIGNED
      ? true
      : config?.completion?.showCorrect === SHOW_ANSWERS.PASSED &&
        unitSelected?.status === UNIT_STATUS.COMPLETED &&
        result?.status !== RESULT_STATUS.NOTASSIGNED
      ? true
      : false);

  const showYourAnswer =
    config?.completion?.preview == 'AFTER' &&
    result?.status !== RESULT_STATUS.NOT_ATTEMPT
      ? true
      : false;
  const showQuestion = showCorrect || showYourAnswer;
  const showCorrectIcon =
    config?.completion?.showCorrect && config?.completion?.preview == 'AFTER'
      ? true
      : false;
  //markinglable
  const showMarkinglabel = config?.completion?.comments;
  // const isCorrect = result?.resultAnswers?.every((answer) => answer.correct);
  const iconsShow = unitSelected?.config?.completion?.labels;
  const renderAnswer = () => {
    //FreeText
    if (result?.type === QUESTION_TYPE.FREETEXT) {
      if (
        isManualMarking(QUESTION_TYPE.FREETEXT) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="">
            <FreeTextMarking result={result} />
          </div>
        );
      }

      return (
        <div className="">
          {showCorrect && (
            <div className="freetext-correct-ans">
              <span className="view-page-title">Correct Answer: </span>
              {result?.type === QUESTION_TYPE.FREETEXT && (
                <div className="whiteSpacePre foo freetext-correct-ans">
                  <div
                    className={
                      `${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                    }}
                  >
                    {iconsShow && (
                      <div
                        className="preview_test_correct_lebalgrade"
                        style={{ float: 'right' }}
                      >
                        Correct
                      </div>
                    )}
                    {result?.config?.answers?.map((dt, index) => (
                      <div className="px-05 py-05">{`${index + 1}. ${
                        dt.words
                      } `}</div>
                    ))}
                    {/* {iconsShow && (
                          <>
                            <Check
                              id="success"
                              color={theme.success}
                              className="float-right"
                            />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        )} */}
                  </div>
                </div>
              )}
            </div>
          )}
          {showYourAnswer && (
            <div className="mt-50">
              <span className="view-page-title ">Your Answer:</span>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div
                  className={`${
                    result?.dataContent === '' ? 'display-none' : ''
                  }`}
                >
                  <div
                    className={
                      `${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? result?.status === RESULT_STATUS.COMPLETED
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {result?.status === RESULT_STATUS.COMPLETED ? (
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ float: 'right' }}
                            >
                              Correct
                            </div>
                          ) : (
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ float: 'right' }}
                            >
                              Incorrect
                            </div>
                          )}
                        </>
                      ) : null
                    ) : null}

                    <span className="">
                      {parseHtml(
                        result?.dataContent,
                        'px-05 py-05 fill-in-the-blank  mtc-order-width',
                      )}
                    </span>
                    {/* {iconsShow && (
                        <>
                          {result?.status === RESULT_STATUS.COMPLETED ? (
                            <>
                              <Check
                                id="success"
                                color={theme.success}
                                className="float-right answer-icon"
                              />
                              <UncontrolledTooltip
                                placement="right"
                                target="success"
                              >
                                This was the correct answer
                              </UncontrolledTooltip>
                            </>
                          ) : (
                            <>
                              <X
                                id="failed"
                                color={theme.danger}
                                className="float-right answer-icon"
                              />
                              <UncontrolledTooltip
                                placement="right"
                                target="failed"
                              >
                                This was the wrong answer
                              </UncontrolledTooltip>
                            </>
                          )}
                        </>
                      )} */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
    //Fill in the blank
    if (result?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      if (
        isManualMarking(QUESTION_TYPE.FILLINTHEBLANK) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="">
            <span className="view-page-title my-1">Your Answer:</span>
            <FillInTheBlankMarking result={result} />
          </div>
        );
      }
      return (
        <div className="">
          {showCorrect && (
            <div>
              <span className="view-page-title">Correct Answer: </span>
              <div className="whiteSpacePre foo freetext-correct-ans">
                <div>
                  <div
                    className={
                      `flexRow fill-overflow-image ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                    }}
                  >
                    {iconsShow && (
                      <div
                        className="preview_test_correct_lebalgrade"
                        style={{ marginLeft: 'auto' }}
                      >
                        Correct
                      </div>
                    )}
                    <span className="w-100 px-md-2 px-05 py-05">
                      {parseHtml(
                        result?.content,
                        'fill-in-the-blank  fill-blank fill-overflow-image',
                      )}
                    </span>
                    {/* {iconsShow && (
                      <div className="blank_test_icon icon-width">
                        <Check id="success" color={theme.success} />
                        <UncontrolledTooltip placement="right" target="success">
                          This was the correct answer
                        </UncontrolledTooltip>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          )}
          {showYourAnswer && (
            <div className="mt-05">
              <span className="view-page-title">Your Answer:</span>
              <div className="whiteSpacePre foo freetext-correct-ans-align">
                <div>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? result?.status === RESULT_STATUS.COMPLETED
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {result?.status === RESULT_STATUS.COMPLETED ? (
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Correct
                            </div>
                          ) : (
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Incorrect
                            </div>
                          )}
                        </>
                      ) : null
                    ) : null}
                    <span className="fill-blank w-100 px-md-2 px-05 py-05">
                      {parseHtml(
                        result?.modifiedContent,
                        'fill-in-the-blank pr-1 fill-overflow-image',
                      )}
                    </span>
                    {/* {iconsShow && (
                      <div className="icon-width">
                        {result?.status === RESULT_STATUS.COMPLETED ? (
                          <>
                            <Check id="success" color={theme.success} />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        ) : (
                          <>
                            <X id="failed" color={theme.danger} />
                            <UncontrolledTooltip
                              placement="right"
                              target="failed"
                            >
                              This was the wrong answer
                            </UncontrolledTooltip>
                          </>
                        )}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    //Fill in the gap
    if (result?.type === QUESTION_TYPE.FILLTHEGAP) {
      if (
        isManualMarking(QUESTION_TYPE.FILLTHEGAP) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="">
            <span className="view-page-title my-1 ">Your Answer:</span>
            <FillInTheGapMarking result={result} />
          </div>
        );
      }
      return (
        <div className="">
          {showCorrect && (
            <div className="freetext-correct-ans">
              <span className="view-page-title">Correct Answer: </span>
              <div className="">
                <div
                  className={
                    `flexRow ${stylesCourse['item-section-normal']}` +
                    ` ${stylesCourse['item-section-enabled']}`
                  }
                  style={{
                    '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                  }}
                >
                  {iconsShow && (
                    <div
                      className="preview_test_correct_lebalgrade"
                      style={{ marginLeft: 'auto' }}
                    >
                      Correct
                    </div>
                  )}
                  <span className=" px-md-2 px-05 py-05 customconten_elecment fill-bank-span w-100 fill-overflow-image">
                    {parseHtml(result?.content)}
                  </span>
                  {/* {iconsShow && (
                    <div className="blank_test_icon icon-width">
                      <Check
                        id="success"
                        color={theme.success}
                        className="float-right"
                      />
                      <UncontrolledTooltip placement="right" target="success">
                        This was the correct answer
                      </UncontrolledTooltip>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          )}
          {showYourAnswer && (
            <div className="mt-50">
              <strong className="view-page-title">Your Answer:</strong>
              <div className="whiteSpacePre foo freetext-correct-ans-align">
                <div>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? result?.status === RESULT_STATUS.COMPLETED
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {result?.status === RESULT_STATUS.COMPLETED ? (
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Correct
                            </div>
                          ) : (
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Incorrect
                            </div>
                          )}
                        </>
                      ) : null
                    ) : null}

                    <span className="px-md-2 px-05 py-05 customconten_elecment fill-bank-span  w-100 fill-overflow-image">
                      {parseHtml(result?.modifiedContent)}
                    </span>
                    {/* {iconsShow && (
                      <div className="icon-width">
                        {result?.status === RESULT_STATUS.COMPLETED ? (
                          <>
                            <Check
                              id="success"
                              color={theme.success}
                              className="float-right"
                            />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        ) : (
                          <>
                            <X
                              id="failed"
                              color={theme.danger}
                              className="float-right"
                            />
                            <UncontrolledTooltip
                              placement="right"
                              target="failed"
                            >
                              This was the wrong answer
                            </UncontrolledTooltip>
                          </>
                        )}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (result?.type === QUESTION_TYPE.DRAGDROP) {
      if (
        isManualMarking(QUESTION_TYPE.DRAGDROP) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans">
            {showCorrect && (
              <section className="mb-1">
                <DragDropMarking
                  asnwer={result?.data.map((item) => item?.correct)}
                  question={result?.data}
                />
              </section>
            )}

            <span className="view-page-title ">Your Answer: </span>
            <Alert className="mt-1 show">
              <DragDropMarking
                asnwer={result?.resultAnswers}
                question={result?.data}
              />
            </Alert>
          </div>
        );
      }
      return (
        <>
          <DragDropResultpage
            result={result}
            showCorrect={showCorrect}
            showYourAnswer={showYourAnswer}
            showCorrectIcon={showCorrectIcon}
            config={config}
            iconsShow={iconsShow}
          />
        </>
      );
    }

    if (result?.type === QUESTION_TYPE.ORDERING) {
      if (
        isManualMarking(QUESTION_TYPE.ORDERING) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans">
            {showCorrect && (
              <section className="mb-1">
                <OrderingMarking result={result?.data} />
              </section>
            )}

            <span className="view-page-title">Your Answer: </span>
            <Alert className="mt-1 show">
              <OrderingMarking result={result?.result} />
            </Alert>
          </div>
        );
      }
      return (
        <OrderingResult
          result={result}
          showCorrect={showCorrect}
          showYourAnswer={showYourAnswer}
          showCorrectIcon={showCorrectIcon}
          config={config}
          iconsShow={iconsShow}
        />
      );
    }

    if (result?.type === QUESTION_TYPE.MTC) {
      if (
        isManualMarking(QUESTION_TYPE.MTC) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return (
          <div className="freetext-correct-ans-align">
            <div className="mb-1">
              <span className="view-page-title">Your Answer:</span>
            </div>
            <Alert className="mt-1 show">
              <MultipleChoiceMarking result={result} />
            </Alert>
            {showMarkinglabel && (
              <>
                {' '}
                {result.markingComments && (
                  <p
                    className="mt-1 mb-0 py-1 px-1"
                    style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
                  >
                    Comment : {result.markingComments}
                  </p>
                )}{' '}
              </>
            )}
          </div>
        );
      }

      return (
        <MTPchoiceResult
          result={result}
          showCorrect={showCorrect}
          showYourAnswer={showYourAnswer}
          showCorrectIcon={showCorrectIcon}
          config={config}
          iconsShow={iconsShow}
        />
      );
    }
    if (result?.type === QUESTION_TYPE.FILLTHEGAP) {
      return (
        <FillTheGapResult
          result={result}
          showCorrect={showCorrect}
          showYourAnswer={showYourAnswer}
          showCorrectIcon={showCorrectIcon}
          config={config}
          iconsShow={iconsShow}
        />
      );
    }

    if (result.type === QUESTION_TYPE.ASSIGNMENT) {
      if (
        isManualMarking(QUESTION_TYPE.ASSIGNMENT) &&
        result?.status === RESULT_STATUS.PENDING
      ) {
        return <AssignmentMarking data={result} />;
      }

      return (
        <AssignmentResult
          data={result}
          showYourAnswer={showYourAnswer}
          iconsShow={iconsShow}
          showQuestion={showQuestion}
          showCorrect={showCorrect}
        />
      );
    }
  };

  const renderQuestion = () => {
    if (
      result?.type === QUESTION_TYPE.FREETEXT ||
      result?.type === QUESTION_TYPE.MTC ||
      result?.type === QUESTION_TYPE.DRAGDROP ||
      result?.type === QUESTION_TYPE.ORDERING ||
      result?.type === QUESTION_TYPE.ASSIGNMENT
    ) {
      return (
        <div className="d-flex">
          {result?.order + ')'}
          {parseHtml(
            result?.content,
            'fill-in-the-blank  fill-overflow-image customconten_elecment w-100 ml-50',
          )}
        </div>
      );
    }
    if (result?.type === QUESTION_TYPE.FILLTHEGAP) {
      return (
        <>
          <div className="freetext-correct-ans">
            <div className="customconten_elecment d-flex fill-overflow-image">
              {result?.order + ')'}{' '}
              {parseHtml(result?.contentHTML, 'ml-50 w-100')}
            </div>
          </div>
        </>
      );
    }
    if (result?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      return (
        <>
          <div className="freetext-correct-ans">
            <div className="d-flex customconten_elecment">
              {result?.order + ')'}{' '}
              {parseHtml(
                result?.contentHTML,
                'fill-in-the-blank pr-1 fill-overflow-image ml-50 w-100',
              )}
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <div className={`${showQuestion ? 'answer-card answer-card-shade' : null}`}>
      <div className="Roboto-Font">
        {unitSelected?.config?.completion?.labels && (
          <>
            {result?.status === RESULT_STATUS.COMPLETED ? (
              <Badge color="success">Correct</Badge>
            ) : result?.status === RESULT_STATUS.FAILED ? (
              <Badge color="danger">Incorrect</Badge>
            ) : result?.status === RESULT_STATUS.PENDING ? (
              <Badge color="light-warning">Instructor Review Required</Badge>
            ) : result?.status === RESULT_STATUS.NOT_ATTEMPT ? (
              <Badge>Not Answered</Badge>
            ) : result?.status === RESULT_STATUS.NOTASSIGNED ? (
              // <Badge color="warning">Not Assigned</Badge>
              <span></span>
            ) : result?.status === RESULT_STATUS.MARKED ? (
              <Badge color="success">Marked</Badge>
            ) : result?.status === RESULT_STATUS.NOT_MARKED ? (
              <Badge color="success">Not Marked</Badge>
            ) : null}
          </>
        )}

        {showQuestion && result?.content && (
          <div className="my-2 m-1 foo quiz-weight">
            <div className="d-flex justify-content-between mb-1">
              <strong className="view-page-title">Question:</strong>

              <div
                className="d-flex align-items-center align-items-center"
                style={{ gap: '10px' }}
              >
                <div className="d-flex justify-content-center align-item-center">
                  <p className="mb-0 custom-marktest-weight ml-1 ">{`${
                    result?.status === RESULT_STATUS.PENDING
                      ? 'Not yet graded'
                      : result?.userWeight ?? 'Not specified'
                  } / ${result?.weight}`}</p>
                </div>
              </div>
            </div>
            {/* <span>
              {parseHtml(
                result?.type === QUESTION_TYPE.FREETEXT ||
                  result?.type === QUESTION_TYPE.MTC ||
                  result?.type === QUESTION_TYPE.DRAGDROP ||
                  result?.type === QUESTION_TYPE.ORDERING
                  ? `<div>${result?.order})  ${result?.content}</div>`
                  : `${result?.order})  ${result?.contentHTML}`,
                'fill-in-the-blank  fill-overflow-image ',
              )}
            </span> */}
            {renderQuestion()}
          </div>
        )}
      </div>
      {result?.status !== RESULT_STATUS.NOT_ATTEMPT && (
        <div className="my-2 m-1 quiz-weight">
          {renderAnswer()}
          {showMarkinglabel && (
            <>
              {result.markingComments && (
                <p
                  className="mt-1 mb-0 py-1 px-1"
                  style={{ backgroundColor: '#f1f1f1', borderRadius: '6px' }}
                >
                  Comment : {result.markingComments}
                </p>
              )}{' '}
            </>
          )}
        </div>
      )}
    </div>
  );
};

ResultItem.propTypes = {
  result: PropTypes.object.isRequired,
  isEnd: PropTypes.bool.isRequired,
};

export default ResultItem;
